import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-up\"><path d=\"M867.171 396.685L544.288 73.802c-27.675-27.676-64.576-27.676-92.252 0L129.153 396.685c-27.676 27.675-27.676 64.576 0 92.252 27.676 27.676 64.577 27.676 92.252 0l212.18-212.18v627.315c0 36.901 27.676 64.577 64.577 64.577s64.577-27.676 64.577-64.577V276.757l212.18 221.405c18.45 9.225 27.676 18.45 46.126 18.45s36.9-9.225 46.126-18.45c27.676-27.676 27.676-73.802 0-101.477z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol